var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_image_filled",
    "data-name": "UI icon/image/filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.934,
    height: 18.934,
    viewBox: "0 0 18.934 18.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M16.095,18.934H2.84A2.843,2.843,0,0,1,0,16.095V2.84A2.843,2.843,0,0,1,2.84,0H16.095a2.843,2.843,0,0,1,2.84,2.84V16.095A2.843,2.843,0,0,1,16.095,18.934ZM6.019,6.206h0A2.832,2.832,0,0,0,3.837,7.23L2.113,9.3a.954.954,0,0,0-.22.607v6.19a.947.947,0,0,0,.947.946H16.095l.078,0a.357.357,0,0,0,.328-.231.747.747,0,0,0-.188-.722l-8.2-8.955a2.808,2.808,0,0,0-2.093-.921ZM14.2,2.84a1.893,1.893,0,1,0,1.894,1.894A1.9,1.9,0,0,0,14.2,2.84Z",
    transform: "translate(0)",
    fill: "#356ab3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpImageIcon);
export default __webpack_public_path__ + "static/media/upImageIcon.b261ce3dcb726941de27a75011cd28ba.svg";
export { ForwardRef as ReactComponent };